<div class="row" role="tabpanel" tabindex="0">
  <div class="col-12 col-lg-6">
    <now-wbsuche-lib-detail-kachel
      [icon]="'now-icon-calendar'"
      [id]="'dauer'"
      [title]="'Dauer'"
      [collapseButtonText]="'zu der Dauer'"
    >
      <now-wbsuche-lib-dauer-termine [termin]="termin"></now-wbsuche-lib-dauer-termine>
    </now-wbsuche-lib-detail-kachel>

    <now-wbsuche-lib-detail-kachel
      [icon]="'now-icon-map-pin-line'"
      [id]="'ort'"
      [title]="'Veranstaltungsort'"
      [collapseButtonText]="'zu dem Veranstaltungsort'"
      (collapsedChanged)="collapseStates.veranstaltungsort = $event"
    >
      <now-wbsuche-lib-veranstaltungsort
        [termin]="termin"
        [collapsed]="collapseStates.veranstaltungsort"
      ></now-wbsuche-lib-veranstaltungsort>
    </now-wbsuche-lib-detail-kachel>
  </div>

  <div class="col-12 col-lg-6">
    <now-wbsuche-lib-detail-kachel
      [icon]="'now-icon-calculator'"
      [id]="'kosten'"
      [title]="'Kosten/Gebühren/Förderung'"
      [collapseButtonText]="'zu den Kosten/Gebühren/Förderung'"
    >
      <now-wbsuche-lib-kosten-gebuehren [termin]="termin"></now-wbsuche-lib-kosten-gebuehren>
    </now-wbsuche-lib-detail-kachel>
    @if ((medianBausteine$ | async)?.length! > 0) {
      <now-wbsuche-lib-detail-kachel
        [icon]="'now-icon-chart-line-up'"
        [id]="'verdienst'"
        [title]="'Verdienst&shy;aussichten'"
        [collapseButtonText]="'zu den Verdienstaussichten'"
        (collapsedChanged)="collapseStates.verdienstaussichten = $event"
      >
        <now-wbsuche-lib-verdienst
          [medianBausteine]="(medianBausteine$ | async)!"
          [collapsed]="collapseStates.verdienstaussichten"
        >
        </now-wbsuche-lib-verdienst>
      </now-wbsuche-lib-detail-kachel>
    }
  </div>
</div>
